<template>

  <div class="my-linktones-view">
    <Teleport to="body">
      <div v-if="view === 'wizard'" class="my-linktones-header-portal">
        <Header :user_data="user_data" :searcProps="searcProps" :num_unreaded="num_unreaded" />
      </div>
    </Teleport>

    <div class="my-linktones-page centered" :data-theme="theme">

      <div class="mlk-app">

        <div class="mlk-container">

          <template v-if="view === 'list'">

            <div class="page-head">

              <div>

                <h1 class="page-head__title">הלינקטונים שלי</h1>

                <p class="page-head__sub">

                  כאן תוכלו ליצור, לערוך ולשלוח לינקטונים לאישור. אפשר לשמור כטיוטה בכל שלב,

                  והתשלום מתבצע רק כשתבחרו לשלוח לאישור.

                </p>

              </div>

              <div class="page-head__actions">

                <button

                  type="button"

                  class="balance-pill"

                  :title="'היתרה שלך — ' + balanceTotal + ' לינקטונים זמינים'"

                  @click="openBalance"

                >

                  <span class="balance-pill__icon"><LtIcon name="wallet" :size="16" /></span>

                  <span class="balance-pill__text">

                    <span>

                      <strong class="balance-pill__num">{{ balanceTotal }}</strong>

                      <span class="balance-pill__suffix"> ביתרה</span>

                    </span>

                    <span class="balance-pill__label">יתרה ורכישות</span>

                  </span>

                  <LtIcon name="arrow-left" :size="16" class="balance-pill__caret" />

                </button>

                <button type="button" class="btn btn--primary btn--lg" @click="openTypeChooser">

                  <LtIcon name="plus" :size="18" /> יצירת לינקטון חדש

                </button>

              </div>

            </div>



            <div class="filters">

              <button

                type="button"

                class="filters__pill"

                :class="{ 'is-active': filter === 'all' }"

                @click="setFilter('all')"

              >

                הכל <span class="count">{{ counts.all }}</span>

              </button>

              <button

                type="button"

                class="filters__pill"

                :class="{ 'is-active': filter === 'drafts' }"

                @click="setFilter('drafts')"

              >

                טיוטות <span class="count">{{ counts.drafts }}</span>

              </button>

              <button

                type="button"

                class="filters__pill"

                :class="{ 'is-active': filter === 'review' }"

                @click="setFilter('review')"

              >

                ממתינים לאישור <span class="count">{{ counts.review }}</span>

              </button>

              <button

                type="button"

                class="filters__pill"

                :class="{ 'is-active': filter === 'published' }"

                @click="setFilter('published')"

              >

                פורסמו <span class="count">{{ counts.published }}</span>

              </button>

              <span class="filters__spacer"></span>

              <button

                v-if="counts.ready > 0"

                type="button"

                class="filters__pill is-attn"

                :class="{ 'is-active': filter === 'attention' }"

                @click="setFilter('attention')"

              >

                <LtIcon name="sparkles" :size="14" /> דורשים פעולה <span class="count">{{ counts.ready }}</span>

              </button>

            </div>



            <div v-if="filtered.length" class="grid">

              <LinktoneCard

                v-for="lt in filtered"

                :key="lt.id"

                :item="lt"

                :balance-for="balanceFor"

                @open="openLinktone"

                @delete="confirmDelete"

              />

            </div>

            <div v-else class="empty">

              <div class="empty__icon"><LtIcon name="music" :size="26" /></div>

              <div class="empty__title">אין לינקטונים בקטגוריה הזו</div>

              <div>כשתוסיפו לינקטון חדש או תשנו פילטר — הוא יופיע כאן.</div>

              <button type="button" class="btn btn--primary empty__cta" @click="openTypeChooser">

                <LtIcon name="plus" :size="16" /> יצירת לינקטון חדש

              </button>

            </div>

          </template>



          <template v-else-if="view === 'wizard'">
            <div class="my-linktones-wizard-shell">
              <div class="subpage-head">
                <button type="button" class="subpage-back" @click="goHome">
                  <LtIcon name="arrow-right" :size="16" /> חזרה ללינקטונים שלי
                </button>
                <div class="subpage-crumbs">
                  <span>הלינקטונים שלי</span>
                  <span class="sep">›</span>
                  <span class="now">{{ wizardTitle }}</span>
                </div>
              </div>
              <WizardPage
                :balance="balance"
                :artist-name="artistName"
                :initial-step="wizardInitialStep"
                :auto-save-status="autoSaveStatus"
                @save-draft="saveDraft"
                @submit-balance="submitWizardBalance"
                @go-buy="onWizardGoBuy"
              />
            </div>
          </template>

          <template v-else-if="view === 'balance'">
            <div class="subpage-head">
              <button type="button" class="subpage-back" @click="goHome">
                <LtIcon name="arrow-right" :size="16" /> חזרה ללינקטונים שלי
              </button>
              <div class="subpage-crumbs">
                <span>הלינקטונים שלי</span>
                <span class="sep">›</span>
                <span class="now">היתרה והרכישות</span>
              </div>
            </div>
            <BalancePage :balance="balance" :products="products" @buy="onBuy" />
          </template>

          <template v-else-if="view === 'payment' && paymentCtx">
            <div class="subpage-head">
              <button type="button" class="subpage-back" @click="onPaymentBack">
                <LtIcon name="arrow-right" :size="16" /> {{ paymentBackLabel }}
              </button>
              <div class="subpage-crumbs">
                <span>הלינקטונים שלי</span>
                <span class="sep">›</span>
                <span v-if="paymentCtx.kind === 'bundle'">היתרה והרכישות</span>
                <template v-else>
                  <span>{{ wizardTitle }}</span>
                  <span class="sep">›</span>
                </template>
                <span class="now">תשלום</span>
              </div>
            </div>
            <PaymentPage :ctx="paymentCtx" @paid="onPaymentComplete" />
          </template>

        </div>

      </div>



      <TypeChooserModal

        v-if="showTypeChooser"

        :balance="balance"

        @close="showTypeChooser = false"

        @choose="onTypeChoose"

        @buy-packages="onBuyPackages"

      />

    </div>

  </div>

</template>



<script>

import '../components/my_linktones/my_linktones.scss';

import Header from '@/components/header.vue';
import LinktoneCard from '../components/my_linktones/LinktoneCard.vue';

import LtIcon from '../components/my_linktones/LtIcon.vue';

import TypeChooserModal from '../components/my_linktones/TypeChooserModal.vue';

import WizardPage from '../components/my_linktones/WizardPage.vue';
import BalancePage from '../components/my_linktones/BalancePage.vue';
import PaymentPage from '../components/my_linktones/PaymentPage.vue';

import { emptyForm } from '../components/my_linktones/data.js';

import { WIZARD_FORM_KEY, WIZARD_UPLOAD_KEY } from '../components/my_linktones/wizardInject.js';



export default {

  name: 'MyLinktones',

  components: { Header, LinktoneCard, LtIcon, TypeChooserModal, WizardPage, BalancePage, PaymentPage },

  provide() {

    return {

      [WIZARD_FORM_KEY]: () => this.wizardForm,

      [WIZARD_UPLOAD_KEY]: (file, type) => this.handleUpload(file, type),

    };

  },

  props: {

    user_data: { type: Object, default: () => ({}) },

    searcProps: { type: Object, default: () => ({}) },

    num_unreaded: { type: Number, default: 0 },

    theme: { type: String, default: 'light' },

  },

  data() {

    return {

      view: 'list',

      filter: 'all',

      linktones: [],

      balance: { single: 0, ep: 0, album: 0 },

      products: [],

      paymentCtx: null,

      showTypeChooser: false,

      wizardForm: null,

      wizardInitialStep: 0,

      autoSaveStatus: 'idle',

      autoSaveTimer: null,

    };

  },

  computed: {

    artistName() {

      const me = this.get_me();

      return me && me.display_name ? me.display_name : 'אמן';

    },

    wizardTitle() {

      if (this.wizardForm && this.wizardForm.name) {

        return 'עריכת ״' + this.wizardForm.name + '״';

      }

      return 'יצירת לינקטון חדש';

    },

    counts() {

      const c = { all: this.linktones.length, drafts: 0, ready: 0, attention: 0, review: 0, published: 0 };

      for (const l of this.linktones) {

        if (l.status === 'draft') c.drafts++;

        if (l.status === 'ready') c.ready++;

        if (l.status === 'ready' || l.status === 'pay' || l.status === 'draft') c.attention++;

        if (l.status === 'review') c.review++;

        if (l.status === 'published') c.published++;

      }

      return c;

    },

    filtered() {

      switch (this.filter) {

        case 'drafts':

          return this.linktones.filter((l) => l.status === 'draft');

        case 'published':

          return this.linktones.filter((l) => l.status === 'published');

        case 'review':

          return this.linktones.filter((l) => l.status === 'review');

        case 'attention':

          return this.linktones.filter((l) => ['draft', 'ready', 'pay'].includes(l.status));

        default:

          return this.linktones;

      }

    },

    balanceTotal() {

      return (this.balance.single || 0) + (this.balance.ep || 0) + (this.balance.album || 0);

    },

    paymentBackLabel() {
      if (!this.paymentCtx) return 'חזרה';
      return this.paymentCtx.kind === 'bundle' ? 'חזרה ליתרה והרכישות' : 'חזרה לעריכת הלינקטון';
    },

  },

  watch: {
    view: {
      immediate: true,
      handler(newVal) {
        this.syncSubview();
        if (this._hashReady && !this._skipHashPush) {
          this.pushViewHash(newVal);
        }
        this._skipHashPush = false;
      },
    },
    wizardForm: {
      deep: true,
      handler() {
        if (!this.wizardForm || !this.wizardForm.id) return;
        this.autoSaveStatus = 'saving';
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
        this.autoSaveTimer = setTimeout(() => {
          this.autoSave();
        }, 1500);
      },
    },
  },

  mounted() {
    this._hashReady = false;
    this._skipHashPush = false;
    this.restoreFromHash();
    this._hashReady = true;
    const base = process.env.BASE_URL || '/';
    history.replaceState({ view: this.view }, '', base + 'my_linktones' + (this.view === 'list' ? '' : '#' + this.view));
    window.addEventListener('popstate', this.onPopState);
    window.addEventListener('hashchange', this.onHashChange);
    this.fetchLinktones();
    this.fetchBalance();
    this.fetchProducts();
    this.syncSubview();
  },

  beforeUnmount() {
    window.removeEventListener('popstate', this.onPopState);
    window.removeEventListener('hashchange', this.onHashChange);
    this.$bus.$emit('my_linktones:view', 'list');
  },

  methods: {
    syncSubview() {
      this.$bus.$emit('my_linktones:view', this.view);
    },

    pushViewHash(view) {
      let hash = '';
      if (view === 'wizard') {
        if (!this.wizardForm || !this.wizardForm.id) return;
        hash = '#wizard/' + this.wizardForm.id;
      } else if (view === 'balance') {
        hash = '#balance';
      }
      const base = process.env.BASE_URL || '/';
      const target = base + 'my_linktones' + hash;
      if (window.location.pathname + window.location.hash !== target) {
        history.pushState(null, '', target);
      }
    },

    onHashChange() {
      if (!this._hashReady) return;
      const hash = window.location.hash.replace('#', '');
      if (!hash && this.view !== 'list') {
        this._skipHashPush = true;
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
        this.autoSaveStatus = 'idle';
        this.view = 'list';
        this.wizardForm = null;
        this.wizardInitialStep = 0;
        this.paymentCtx = null;
      }
    },

    onPopState() {
      this._skipHashPush = true;
      const hash = window.location.hash.replace('#', '');
      if (!hash || hash === 'list') {
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
        this.autoSaveStatus = 'idle';
        this.view = 'list';
        this.wizardForm = null;
        this.wizardInitialStep = 0;
        this.paymentCtx = null;
      } else if (hash === 'balance') {
        this.view = 'balance';
      } else if (hash.startsWith('wizard/')) {
        const id = parseInt(hash.split('/')[1]);
        if (id > 0 && (!this.wizardForm || this.wizardForm.id !== id)) {
          this.api({ action: 'my_linktones/get', data: { id: id } }, (res) => {
            const d = res && res.data ? res.data : res;
            if (d && !d.error) {
              this.wizardForm = {
                id: d.id, name: d.name, type: d.type, artist: d.artist,
                overrideArtistName: d.overrideArtistName || '',
                label: d.label || [], releaseDate: d.releaseDate || '',
                images: { main: d.images.main, catalog: d.images.catalog, email: d.images.email, gallery: d.gallery || [] },
                youtube: d.youtube || '',
                comms: { pressReleasePdf: d.comms.pressReleasePdf, pressReleaseDoc: d.comms.pressReleaseDoc, lyrics: d.comms.lyrics, credits: d.comms.credits, creditsText: d.comms.creditsText || '', stickerText: d.comms.stickerText || '' },
                tracks: (d.tracks || []).map(function(t) {
                  const na = (v) => (v && typeof v === 'number' ? { storage_id: v, name: '', size: '' } : v || null);
                  const audio = t.audio || {};
                  return { name: t.name, writer: t.writer || '', composer: t.composer || '', duration: t.duration || '', lyrics: t.lyrics || '', audio: { wav: na(audio.wav), mp3_320: na(audio.mp3_320), mp3_128: na(audio.mp3_128), mp2: na(audio.mp2) } };
                }),
                agreed: false, uuid: d.uuid,
                isPublished: !!d.isPublished,
          isAired: !!d.isAired,
              };
              this.wizardInitialStep = 0;
              this.view = 'wizard';
            } else {
              this.view = 'list';
            }
          });
        } else {
          this.view = 'wizard';
        }
      } else {
        this.view = 'list';
      }
    },

    restoreFromHash() {
      const hash = window.location.hash.replace('#', '');
      if (hash === 'balance') {
        this.view = 'balance';
      } else if (hash.startsWith('wizard/')) {
        const id = parseInt(hash.split('/')[1]);
        if (id > 0) {
          this.api({ action: 'my_linktones/get', data: { id: id } }, (res) => {
            const d = res && res.data ? res.data : res;
            if (d && !d.error) {
              this.wizardForm = {
                id: d.id, name: d.name, type: d.type, artist: d.artist,
                overrideArtistName: d.overrideArtistName || '',
                label: d.label || [], releaseDate: d.releaseDate || '',
                images: { main: d.images.main, catalog: d.images.catalog, email: d.images.email, gallery: d.gallery || [] },
                youtube: d.youtube || '',
                comms: { pressReleasePdf: d.comms.pressReleasePdf, pressReleaseDoc: d.comms.pressReleaseDoc, lyrics: d.comms.lyrics, credits: d.comms.credits, creditsText: d.comms.creditsText || '', stickerText: d.comms.stickerText || '' },
                tracks: (d.tracks || []).map(function(t) {
                  const na = (v) => (v && typeof v === 'number' ? { storage_id: v, name: '', size: '' } : v || null);
                  const audio = t.audio || {};
                  return { name: t.name, writer: t.writer || '', composer: t.composer || '', duration: t.duration || '', lyrics: t.lyrics || '', audio: { wav: na(audio.wav), mp3_320: na(audio.mp3_320), mp3_128: na(audio.mp3_128), mp2: na(audio.mp2) } };
                }),
                agreed: false, uuid: d.uuid,
                isPublished: !!d.isPublished,
          isAired: !!d.isAired,
              };
              this.wizardInitialStep = 0;
              this.view = 'wizard';
            }
          });
        }
      }
    },

    balanceFor(type) {

      return this.balance[type] || 0;

    },

    setFilter(f) {

      this.filter = f;

    },

    openTypeChooser() {

      this.showTypeChooser = true;

    },

    onTypeChoose(typeKey) {

      this.showTypeChooser = false;

      this.wizardForm = emptyForm(typeKey, this.artistName);

      this.wizardInitialStep = 0;

      this.view = 'wizard';

      this.api({ action: 'my_linktones/create', data: { name: 'לינקטון חדש', type: typeKey } }, (res) => {
        const d = res && res.data ? res.data : res;
        if (d && d.id) {
          this.wizardForm.id = d.id;
          this.wizardForm.uuid = d.uuid;
          this.pushViewHash('wizard');
        }
      });

    },

    onBuyPackages() {
      this.showTypeChooser = false;
      this.view = 'balance';
    },

    openBalance() {
      this.view = 'balance';
    },

    onBuy(opt) {
      this.paymentCtx = {
        kind: 'bundle',
        product_id: opt.id,
        items: [{ name: opt.name, price: opt.price }],
      };
      this.view = 'payment';
    },

    onWizardGoBuy() {
      this.view = 'balance';
    },

    onPaymentComplete(payload) {
      const ctx = this.paymentCtx;
      this.paymentCtx = null;
      if (!ctx) return;

      if (ctx.kind === 'linktone') {
        this.completeSubmission('pay');
        return;
      }

      if (ctx.kind === 'bundle') {
        if (payload && payload.balance) {
          this.balance = payload.balance;
        } else {
          this.fetchBalance();
        }
        this.view = 'balance';
        this.success('התשלום בוצע — היתרה עודכנה');
      }
    },

    onPaymentBack() {
      const ctx = this.paymentCtx;
      this.paymentCtx = null;
      if (ctx && ctx.returnView === 'wizard') {
        this.view = 'wizard';
      } else {
        this.view = 'balance';
      }
    },

    goHome() {
      if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
      this.autoSaveStatus = 'idle';
      this.view = 'list';
      this.wizardForm = null;
      this.wizardInitialStep = 0;
      this.paymentCtx = null;
    },

    buildPayload() {
      const sid = (val) => {
        if (!val) return 0;
        if (typeof val === 'number') return val;
        if (val && val.storage_id) return val.storage_id;
        return 0;
      };
      const tracks = (this.wizardForm.tracks || []).map(t => ({
        name: t.name,
        writer: t.writer || '',
        composer: t.composer || '',
        duration: t.duration || '',
        lyrics: t.lyrics || '',
        audio: {
          wav: sid(t.audio && t.audio.wav),
          mp3_320: sid(t.audio && t.audio.mp3_320),
          mp3_128: sid(t.audio && t.audio.mp3_128),
          mp2: sid(t.audio && t.audio.mp2),
        },
      }));
      return {
        id: this.wizardForm.id,
        name: this.wizardForm.name || 'לינקטון חדש',
        type: this.wizardForm.type,
        override_artist_name: this.wizardForm.overrideArtistName || '',
        releaseDate: this.wizardForm.releaseDate || '',
        youtube: this.wizardForm.youtube || '',
        label: (this.wizardForm.label || []).map((c) => c.id),
        pic_cover: sid(this.wizardForm.images.main),
        pic_catalog: sid(this.wizardForm.images.catalog),
        override_mail_pic: sid(this.wizardForm.images.email),
        press_pdf: sid(this.wizardForm.comms.pressReleasePdf),
        press_doc: sid(this.wizardForm.comms.pressReleaseDoc),
        press_lyrics: sid(this.wizardForm.comms.lyrics),
        press_credits: sid(this.wizardForm.comms.credits),
        credits: this.wizardForm.comms.creditsText || '',
        sticker_text: this.wizardForm.comms.stickerText || '',
        tracks,
      };
    },

    autoSave() {
      if (!this.wizardForm || !this.wizardForm.id) return;
      this.api({ action: 'my_linktones/update', data: this.buildPayload() }, () => {
        this.autoSaveStatus = 'saved';
        this.fetchLinktones();
      });
    },

    saveDraft() {
      if (!this.wizardForm) return;
      if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
      if (this.wizardForm.id) {
        this.api({ action: 'my_linktones/update', data: this.buildPayload() }, () => {
          this.fetchLinktones();
          this.goHome();
        });
      } else {
        this.goHome();
      }
    },

    submitWizardBalance() {
      if (!this.wizardForm || !this.wizardForm.id) return;
      this.api({ action: 'my_linktones/submit', data: { id: this.wizardForm.id } }, (res) => {
        const d = res && res.data ? res.data : res;
        if (d && d.success) {
          if (d.balance) this.balance = d.balance;
          this.success('הלינקטון נשלח לאישור');
          this.fetchLinktones();
          this.goHome();
        } else {
          this.alert(d && d.error ? d.error : 'שגיאה בשליחה');
        }
      });
    },

    handleUpload(file, type) {
      return new Promise((resolve, reject) => {
        if (!this.wizardForm || !this.wizardForm.id) {
          reject('no_linktone_id');
          return;
        }
        const fd = new FormData();
        fd.append('file', file);
        fd.append('id', this.wizardForm.id);
        if (type) fd.append('type', type);

        this.api({ action: 'my_linktones/upload', data: fd }, (res) => {
          const d = res && res.data ? res.data : res;
          if (d && d.success) {
            resolve({ storage_id: d.storage_id, name: d.filename || file.name, size: this.formatSize(file.size), preview: d.preview || null });
          } else {
            reject(d && d.error ? d.error : 'upload_failed');
          }
        }, () => {
          reject('upload_failed');
        });
      });
    },

    formatSize(bytes) {
      if (bytes < 1024) return bytes + 'B';
      if (bytes < 1048576) return (bytes / 1024).toFixed(1) + 'KB';
      return (bytes / 1048576).toFixed(1) + 'MB';
    },

    fetchLinktones() {
      this.api({ action: 'my_linktones/list' }, (res) => {
        this.linktones = (res && res.data) ? res.data : [];
      });
    },

    fetchBalance() {
      this.api({ action: 'my_linktones/balance' }, (res) => {
        const d = res && res.data ? res.data : res;
        if (d && !d.error) {
          this.balance = d;
        }
      });
    },

    fetchProducts() {
      this.api({ action: 'my_linktones/products_list' }, (res) => {
        const d = res && res.data ? res.data : res;
        if (Array.isArray(d)) {
          this.products = d;
        }
      });
    },

    confirmDelete(item) {
      const vm = this;
      vm.$swal.fire({
        html: 'האם למחוק את הלינקטון ״' + item.name + '״?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'מחק',
        cancelButtonText: 'ביטול',
      }).then(function(result) {
        if (result.isConfirmed) {
          vm.api({ action: 'my_linktones/delete', data: { id: item.id } }, function() {
            vm.success('הלינקטון נמחק');
            vm.fetchLinktones();
          });
        }
      });
    },

    openLinktone({ item, intent }) {
      if (intent === 'preview') {
        if (item.link) {
          const url = item.link.startsWith('http') ? item.link : 'https://www.linktone.co.il' + item.link;
          if (item.pass) {
            this.$swal.fire({
              html: 'סיסמא לצפייה:<br><b>' + item.pass + '</b>',
              confirmButtonText: 'מעבר ללינקטון',
            }).then((result) => {
              if (result.isConfirmed) {
                window.open(url, '_blank');
              }
            });
          } else {
            window.open(url, '_blank');
          }
        }
        return;
      }
      if (intent !== 'edit' && !item.editable) {
        return;
      }
      this.api({ action: 'my_linktones/get', data: { id: item.id } }, (res) => {
        const d = res && res.data ? res.data : res;
        if (d.error) { this.alert(d.error); return; }
        this.wizardForm = {
          id: d.id,
          name: d.name,
          type: d.type,
          artist: d.artist,
          overrideArtistName: d.overrideArtistName || '',
          label: d.label || [],
          releaseDate: d.releaseDate || '',
          images: {
            main: d.images.main,
            catalog: d.images.catalog,
            email: d.images.email,
            gallery: d.gallery || [],
          },
          youtube: d.youtube || '',
          comms: {
            pressReleasePdf: d.comms.pressReleasePdf,
            pressReleaseDoc: d.comms.pressReleaseDoc,
            lyrics: d.comms.lyrics,
            credits: d.comms.credits,
            creditsText: d.comms.creditsText || '',
            stickerText: d.comms.stickerText || '',
          },
          tracks: (d.tracks || []).map(t => {
            const na = (v) => (v && typeof v === 'number' ? { storage_id: v, name: '', size: '' } : v || null);
            const audio = t.audio || {};
            return { name: t.name, writer: t.writer || '', composer: t.composer || '', duration: t.duration || '', lyrics: t.lyrics || '', audio: { wav: na(audio.wav), mp3_320: na(audio.mp3_320), mp3_128: na(audio.mp3_128), mp2: na(audio.mp2) } };
          }),
          agreed: false,
          uuid: d.uuid,
          isPublished: !!d.isPublished,
          isAired: !!d.isAired,
        };
        this.wizardInitialStep = 0;
        this.view = 'wizard';
      });
    },

  },

};

</script>

